import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash-es';
import style from './areaTable.css';
import Arrow from './arrow';
import { formatSumData, classNames } from '../../utils/utils';

/* 格式化疫苗展示 */
const formatVaccinebrands = function formatVaccinebrands(text) {
    if (text && text !== '') {
        const brands = text.split(',');
        const len = brands.length - 1;

        return brands.map((item, index) => {
            if (['科兴生物', '康希诺', '国药'].includes(item) || /^国药\//.test(item)) {
                return (
                    <span key={item} className={style.company}>
                        {item}
                        {index !== len ? '，' : ''}
                    </span>
                );
            } else {
                return (
                    <span key={item} className={style.companyText}>
                        {item}
                        {index !== len ? '，' : ''}
                    </span>
                );
            }
        });
    } else {
        return [];
    }
};

/* 疫苗接种表格 */
const AreaTable = function AreaTable(props) {
    const { area } = props;
    const [sortType, setSortType] = useState('total'); // 排序类型total或per_hundred
    const [orderType, setOrderType] = useState('desc'); // desc：降序 asc：升序

    // 排序
    const formatData = useMemo(() => {
        return orderBy(area, o => o[sortType] || 0, [orderType]);
    }, [area, sortType, orderType]);

    /* 渲染td */
    const tdListRender = function tdListRender() {
        return formatData.map((item, index) => {
            const { num: num0, unit: unit0 } = formatSumData(item.total);
            const { num: num1, unit: unit1 } = formatSumData(item.per_hundred, '-');
            const dateArr = item.date.split(/-/);

            return (
                <tr key={item.country}>
                    <td>{item.country}</td>
                    <td>
                        {num0}
                        {unit0}剂
                    </td>
                    <td>
                        {num1}
                        {unit1}
                        {num1 !== '-' && '剂'}
                    </td>
                    <td className={style.firm}>{formatVaccinebrands(item.vaccinebrands)}</td>
                    <td>
                        {Number(dateArr[1])}.{Number(dateArr[2])}
                    </td>
                </tr>
            );
        });
    };

    // 按累计接种点击排序
    const handleTotalOrderClick = function handleTotalOrderClick(event) {
        if (sortType === 'total') {
            setOrderType(orderType === 'desc' ? 'asc' : 'desc');
        } else {
            setSortType('total');
            setOrderType('desc');
        }
    };

    // 按每百人接种点击排序
    const handlePerHundredOrderClick = function handlePerHundredOrderClick(event) {
        if (sortType === 'per_hundred') {
            setOrderType(orderType === 'desc' ? 'asc' : 'desc');
        } else {
            setSortType('per_hundred');
            setOrderType('desc');
        }
    };

    return (
        <div className={style.tableBox}>
            <table className={style.table}>
                <thead>
                    <tr>
                        <th className={style.td0}>国家(地区)</th>
                        <th>
                            <div
                                className={style.sort}
                                role="button"
                                aria-label="按累计接种排序"
                                onClick={handleTotalOrderClick}>
                                累计接种
                                <Arrow highlight={sortType === 'total' ? orderType : undefined} />
                            </div>
                        </th>
                        <th>
                            <div
                                className={style.sort}
                                role="button"
                                aria-label="按每百人接种排序"
                                onClick={handlePerHundredOrderClick}>
                                每百人
                                <Arrow highlight={sortType === 'per_hundred' ? orderType : undefined} />
                            </div>
                        </th>
                        <th className={classNames(style.td3, style.firm)}>疫苗研制单位</th>
                        <th className={style.td4}>更新时间</th>
                    </tr>
                </thead>
                <tbody className={style.tbody}>{tdListRender()}</tbody>
            </table>
        </div>
    );
};

AreaTable.propTypes = {
    area: PropTypes.array,
};

export default AreaTable;
